"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageQuoteTotalStore = void 0;
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var AngularSyncStore_1 = __importDefault(require("Utils/AngularSyncStore"));
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var omitByDeep_1 = __importDefault(require("@CommonFrontendBackend/Utils/omitByDeep"));
var ProjectCurrencies_1 = __importDefault(require("QuoteV2/ProjectCurrencies"));
var CalculateProject_1 = require("QuoteV2/Calculator/CalculateProject");
var FormatCurrency_1 = require("Utils/FormatCurrency");
var PROPS_TO_IGNORE = [
    "content",
    "contentAreas",
    "description",
    "integrationSettings",
    "style",
    "tokens",
    "viewSettings",
];
var quoteBlockExtractor = function (blocks) {
    var quoteBlocks = blocks.filter(function (b) { return b.type === BlockTypes_1.BlockType.Quote; });
    return (0, omitByDeep_1.default)(quoteBlocks, function (key) { return (key !== "$id" && key.startsWith("$")) || PROPS_TO_IGNORE.includes(key); });
};
var PageQuoteTotalStore = (function (_super) {
    __extends(PageQuoteTotalStore, _super);
    function PageQuoteTotalStore(initialData, projectStore, accountQuoteSettings, variableService, discountService, billingScheduleOrchestrator, services) {
        var _this = _super.call(this, initialData.blocks, services, {
            extractDataFromAngular: quoteBlockExtractor,
            skipDiffOnAngularChange: true,
        }) || this;
        _this.projectStore = projectStore;
        _this.accountQuoteSettings = accountQuoteSettings;
        _this.variableService = variableService;
        _this.discountService = discountService;
        _this.billingScheduleOrchestrator = billingScheduleOrchestrator;
        _this.onAngularUpdated = function (quoteBlocks) {
            _this.quoteBlocks = quoteBlocks;
        };
        _this.acceptanceDataSubset = getAcceptanceData(initialData);
        _this.quoteBlocks = quoteBlockExtractor(initialData.blocks);
        return _this;
    }
    Object.defineProperty(PageQuoteTotalStore.prototype, "formattedQuoteValue", {
        get: function () {
            return this.getFormattedValue(false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageQuoteTotalStore.prototype, "formattedPageValue", {
        get: function () {
            return this.getFormattedValue(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageQuoteTotalStore.prototype, "hasQuoteCurrency", {
        get: function () {
            return this.quoteBlocks.length > 0 && !ProjectCurrencies_1.default.hasMultipleCurrencies(this.quoteBlocks);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageQuoteTotalStore.prototype, "showDecimalPlaces", {
        get: function () {
            return (this.quoteBlocks.length > 0 && this.quoteBlocks.some(function (block) { var _a, _b, _c; return (_c = (_b = (_a = block.settings) === null || _a === void 0 ? void 0 : _a.view) === null || _b === void 0 ? void 0 : _b.showDecimalPlaces) !== null && _c !== void 0 ? _c : true; }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageQuoteTotalStore.prototype, "showQuoteTotal", {
        get: function () {
            return (this.quoteBlocks.length > 0 && this.quoteBlocks.some(function (block) { var _a, _b, _c; return (_c = (_b = (_a = block.settings) === null || _a === void 0 ? void 0 : _a.view) === null || _b === void 0 ? void 0 : _b.showQuoteTotals) !== null && _c !== void 0 ? _c : true; }));
        },
        enumerable: false,
        configurable: true
    });
    PageQuoteTotalStore.prototype.getCurrency = function (includeManualPageValue) {
        var _a;
        if (((_a = this.acceptanceDataSubset) === null || _a === void 0 ? void 0 : _a.currency) != undefined) {
            return this.acceptanceDataSubset.currency;
        }
        if (this.hasQuoteCurrency) {
            return ProjectCurrencies_1.default.getSingleCurrency(this.quoteBlocks);
        }
        if (includeManualPageValue) {
            var manualPageValue = this.projectStore.manualPageValue;
            return (manualPageValue === null || manualPageValue === void 0 ? void 0 : manualPageValue.enabled) ? manualPageValue.currency : null;
        }
        return null;
    };
    PageQuoteTotalStore.prototype.getCurrencyLocale = function () {
        return this.projectStore.currencyLocale;
    };
    PageQuoteTotalStore.prototype.getTotal = function (includeManualPageValue) {
        var _a, _b, _c;
        if (((_a = this.acceptanceDataSubset) === null || _a === void 0 ? void 0 : _a.acceptedTotalWithTaxes) != undefined) {
            return this.acceptanceDataSubset.acceptedTotalWithTaxes;
        }
        if (includeManualPageValue && ((_b = this.projectStore.manualPageValue) === null || _b === void 0 ? void 0 : _b.enabled)) {
            return this.projectStore.manualPageValue.value;
        }
        var projectCosts = (0, CalculateProject_1.calculateProject)(this.quoteBlocks, (_c = this.accountQuoteSettings.taxes) !== null && _c !== void 0 ? _c : [], this.variableService, this.discountService, this.billingScheduleOrchestrator, true);
        var totals = (0, lodash_1.mapValues)(projectCosts, function (f) { return f.postTax; });
        return totals[Object.keys(totals)[0]];
    };
    PageQuoteTotalStore.prototype.getFormattedValue = function (includeManualPageValue) {
        var currency = this.getCurrency(includeManualPageValue);
        if (!currency) {
            return null;
        }
        var total = this.getTotal(includeManualPageValue);
        return (0, FormatCurrency_1.formatCurrency)(total, currency, undefined, this.projectStore.currencyLocale);
    };
    Object.defineProperty(PageQuoteTotalStore.prototype, "dataForAngular", {
        get: function () {
            return this.quoteBlocks;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], PageQuoteTotalStore.prototype, "quoteBlocks", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PageQuoteTotalStore.prototype, "formattedQuoteValue", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PageQuoteTotalStore.prototype, "formattedPageValue", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PageQuoteTotalStore.prototype, "onAngularUpdated", void 0);
    return PageQuoteTotalStore;
}(AngularSyncStore_1.default));
exports.PageQuoteTotalStore = PageQuoteTotalStore;
function getAcceptanceData(initialData) {
    if (initialData.acceptanceData) {
        var _a = initialData.acceptanceData, acceptedTotalWithTaxes = _a.acceptedTotalWithTaxes, currency = _a.currency;
        return { acceptedTotalWithTaxes: acceptedTotalWithTaxes, currency: currency };
    }
    if (initialData.partialAcceptanceData) {
        var _b = initialData.partialAcceptanceData, acceptedTotalWithTaxes = _b.acceptedTotalWithTaxes, currency = _b.currency;
        return { acceptedTotalWithTaxes: acceptedTotalWithTaxes, currency: currency };
    }
    return undefined;
}
